export enum TabState {
  Default = 'DEFAULT',
  Selected = 'SELECTED',
  Disabled = 'DISABLED',
  DisabledSelected = 'DISABLED_SELECTED',
}

export type Tab = {
  /** True if the tab is actively selected */
  isSelected?: boolean;
  /** True if the tab is disabled */
  isDisabled?: boolean;
  /** Function called when tab is clicked */
  onClick?: () => void;
  /** Text displayed in the tab */
  label?: string;
  /** Content displayed in the tab for custom tab content */
  children?: React.ReactNode;
  /** Unique id used to differentiate and select labels */
  id: string;
  /** Square variant (square instead of rounded buttons) */
  squareTheme?: boolean;
};

export type TabGroup = {
  /** Id of active tab */
  selectedTab?: string;
  /** Function to be called when a different tab becomes active, takes in id of tab clicked */
  onTabChange?: (tabId: any) => void;
  /** Tabs to be displayed within the tab group */
  children: React.ReactNode;
};
